export enum Category {
  FEATURED = 'Featured',
  ALL = 'All',
  INTERIOR = 'Interior',
  EXTERIOR = 'Exterior',
  PACKAGE = 'Packages'
}